<template>
    <v-app class="main-dashboard">
        <v-navigation-drawer
            v-model="drawer"
            app
            dark
            :permanent="($vuetify.breakpoint.xlAndUp) ? true : false"
            style="background-color: #3C3C3C;"
        >

            <!-- main list -->
            <v-list class="pt-0" dense v-if="showDrawer">
                <v-img
                    :src="banner.includes('bg-store') ? '' : banner"
                    height="120px"
                    class="align-end bg-red"
                    gradient="to bottom, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                >
                    <v-list>
                        <v-list-item>
                            <v-img
                                :src="logo"
                                alt="admin"
                                height="auto"
                                max-width="85px"
                                class="mr-2 rounded-lg"
                                v-if="!logo.includes('logo-default')"
                            />
                            <v-list-item-content>
                                <v-list-item-title>{{ userName }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-img>

                <div id="switch-container" style="padding: 5px; ">
                    <div id="switch-app"></div>
                </div>

                <sales-expenses
                    :slug="slug"
                    :money="money"
                    :btn-sale="showBtnNewSales"
                    :btn-expense="showBtnNewExpense"
                    :type-store="typeStore"
                    v-if="physicalStore"
                />

                <!-- <div class="px-3 mb-4" v-if="physicalRestaurant">
                    <v-btn
                        color="primary"
                        dark
                        class="capitalize"
                        small
                        block
                        :href="physicalRestaurantUrl"
                        target="_blank"
                    >Restaurante fīsico</v-btn>
                </div> -->

                <!-- main menu -->
                <template v-for="(item, index) in items">

                    <!-- <v-list-item :key="index" v-if="item.header">
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item> -->

                    <template v-if="item.role==userRole || item.role==''">
                        <v-list-item
                            :key="index"
                            link
                            :href="item.path"
                            :target="item.title=='Diseño' ? '_blank' : ''"
                            :class="[(path == item.path) ? 'active' : '']"
                            v-if="!item.header && !item.subItems && item.show"
                        >
                            <v-list-item-icon>
                                <v-icon :color="(path == item.path)?'primary':''">mdi-{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title :class="(path == item.path)?'primary--text':''">
                                {{ item.title }}
                            </v-list-item-title>
                            <v-list-item-action v-if="item.title=='Ventas Digitales'">
                                <v-badge
                                    inline
                                    :value="cantOrder"
                                    :content="cantOrder"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                            <v-list-item-action v-if="item.title=='Pedidos, puntos de venta'">
                                <v-badge
                                    inline
                                    :value="cantOrder2"
                                    :content="cantOrder2"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                            <v-list-item-action v-if="item.title=='Preventas'">
                                <v-badge
                                    inline
                                    :value="cantOrder3"
                                    :content="cantOrder3"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                        </v-list-item>
                    </template>

                    <template v-if="item.role==userRole || item.role==''">
                        <v-list-group
                            :key="index"
                            v-model="item.active"
                            :prepend-icon="`mdi-${item.icon}`"
                            no-action
                            v-if="!item.header && item.subItems && item.show"
                            color="white"
                        >
                            <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                            </template>

                            <v-list-item
                                v-for="child in item.subItems"
                                :key="child.title"
                                link
                                :href="child.path"
                                :class="[(path == child.path) ? 'active' : '']"
                                :disabled="child.disabled"
                                v-if="child.show"
                            >
                                <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between" :class="(path == child.path)?'primary--text':''">
                                        {{ child.title }}
                                        <v-badge
                                            inline
                                            :value="cantOrder"
                                            :content="cantOrder"
                                            color="error"
                                            class="mt-0"
                                            v-if="child.title=='Ventas Digitales'"
                                        ></v-badge>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                    </template>

                </template>
                <!-- end main menu -->

            </v-list>
            <!-- end main list -->

            <v-list v-else>
                <v-list-item>
                    <v-list-item-content>
                        <v-skeleton-loader
                        class="mx-auto"
                        type="card, text, text, text"
                        ></v-skeleton-loader>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div class="pa-5 white--text text-center logo-menu">
                Potenciado por
                <v-img
                    src="/images/quick2.png"
                    width="100%"
                    max-width="150px"
                    class="mx-auto mt-2"
                ></v-img>
            </div>

        </v-navigation-drawer>

        <!-- main appbar -->
        <v-app-bar
            app
        >
            <!-- btn drawer -->
            <v-app-bar-nav-icon color="primary" @click.stop="drawer = !drawer" v-show="!$vuetify.breakpoint.lgAndUp"></v-app-bar-nav-icon>

            <!-- <v-spacer> -->
            <a href="#"
                title="Ayuda" target="_blank" class="btn btn-sm py-0 pt-2 d-block" style="font-size: 1.5em;"
                @click.prevent="showTutoriales"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width=25 height=25 >
                    <path fill="white" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3" />
                    <path fill="red" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                </svg>
            </a>
            <v-menu offset-y v-if="userRole=='store' && branches.length>0">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ml-4"
                        outlined
                    >
                        {{ branches.filter(b=>b.slug==slug)[0].name_store }}
                        <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="child in branches"
                        :key="child.name_store"
                        :disabled="child.slug==slug"
                        @click.prevent="changeBranch(child.slug)"
                    >
                        <v-list-item-title :class="{'current--text':child.type_store=='main'}">{{ child.name_store }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer/>

            <!-- my site -->
            <v-btn
                color="error"
                outlined
                class="mr-3"
                v-if="typeCash=='open' && !btnCloseCash && userRole!=='admin'"
                @click="dialogCash=true, typeCash='close'"
            >Cerrar caja</v-btn>
            <v-btn
                target="_blank"
                :href="`/${slug}`"
                color="primary"
                class="mr-3"
                v-if="slug!=''"
            >Ir a mi sitio</v-btn>
            <!-- my site end -->

            <!-- menu account -->
            <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="mr-0"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>
                <v-list dense min-width="250px">
                    <v-list-item>
                        <v-list-item-avatar>
                            <img
                                src="/images/user-default.png"
                                alt="admin"
                                style="object-fit:cover; object-position:center;"
                            >
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ userName }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :href="`${userRole=='admin' ? '/admin/my-account' : '/admin/my-store'}`">
                        <v-list-item-icon>
                            <v-icon>mdi-account-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Mi cuenta</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/logout" @click.prevent="logout">
                        <v-list-item-icon>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Cerrar sesión</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="userRole!=='admin'" :class="(ifEmergency)?'success':'error'" dark @click="changeEmergency">
                        <v-list-item-icon>
                            <v-icon>mdi-exit-run</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ (ifEmergency)?'Abrir tienda':'Cerrar por emergencia' }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- end menu account -->

        </v-app-bar>
        <!-- end main appbar -->

        <v-main class="grey lighten-3">
            <slot/>

            <!-- boton whatsapp -->
            <v-fab-transition>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            large
                            dark
                            fixed
                            bottom
                            right
                            v-bind="attrs"
                            v-on="on"
                            color="#28ac00"
                            :href="`https://wa.me/59169422693?text=Hola%20Necesito%20ayuda%20con%20la%20tienda%20${slug}.`"
                            target="_blank"
                        >
                            <v-icon>mdi-whatsapp</v-icon>
                        </v-btn>
                    </template>
                    <span>¿Necesitas ayuda?</span>
                </v-tooltip>
            </v-fab-transition>
            <!-- end boton whatsapp -->
        </v-main>

        <!-- <v-footer
            app
            inset
        >
            <span>Quick Restaurantes &copy; {{ new Date().getFullYear() }}</span>
        </v-footer> -->

        <!-- dialog cash -->
        <v-dialog
            v-model="dialogCash"
            persistent
            max-width="350"
        >
            <open-cash :type-cash="typeCash" @close-modal="dialogCash=false" :money="money"></open-cash>
        </v-dialog>
        <!-- END dialog cash -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity="1" z-index="10" color="grey lighten-3">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-app>
</template>
<style>
    .dd-option-text, .dd-selected-text {
        color: black !important;
    }
</style>
<script>

export default {
    data() {
        return {
            overlay: false,
            drawer: null,
            path: '/',
            items: [
                {
                    header: true,
                    role: '',
                    title: ''
                },
                // admin
                {
                    header: false,
                    role: 'admin',
                    icon: 'view-dashboard',
                    title: 'Mi panel',
                    path: '/admin/dashboard',
                    show: true
                },
                {
                    header: false,
                    role: 'admin',
                    icon: 'store',
                    title: 'Negocios',
                    subItems: [
                        { title: 'Nuevo registro', path: '/admin/new-store', disabled: false, show:true },
                        { title: 'Listar negocios', path: '/admin/stores', disabled: false, show:true },
                    ],
                    show: true
                },
                {
                    header: false,
                    role: 'admin',
                    icon: 'domain',
                    title: 'Tiendas matriz',
                    subItems: [
                        { title: 'Nuevo registro', path: '/admin/new-parent-store', disabled: false, show:true },
                        { title: 'Listar Tiendas', path: '/admin/parent-stores', disabled: false, show:true },
                    ],
                    show: true
                },
                // store
                {
                    header: false,
                    role: 'store',
                    icon: 'cart',
                    title: 'Ventas',
                    // path: '/admin/orders',
                    show: false,
                    // permission: 'view_orders'
                    subItems: [
                        { title: 'Ventas Digitales', path: '/admin/orders', disabled: false, show: false, permission: 'view_orders' },
                        { title: 'Ventas Fisicas', path: '/admin/orders-physical', disabled: false, show: false, permission: 'view_orders_physical' },
                    ],
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cash',
                    title: 'Gastos',
                    path: '/admin/expenses',
                    show: false,
                    permission: 'view_expenses'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cube',
                    title: 'Productos/Servicios',
                    subItems: [
                        { title: 'Nuevo producto', path: '/admin/new-product', disabled: false, show: false, permission: 'create_products' },
                        { title: 'Nuevo servicio', path: '/admin/new-service', disabled: false, show: false, permission: 'create_services' },
                        { title: 'Listar productos/servicios', path: '/admin/products', disabled: false, show: false, permission: 'view_products' },
                        { title: 'Categorías', path: '/admin/categories', disabled: false, show: false, permission: 'view_categories' },
                        { title: 'Complementos', path: '/admin/complements', disabled: false, show: false, permission: 'view_complements' },
                    ],
                    show: false
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'table-large',
                    title: 'Inventario',
                    path: '/admin/inventory',
                    show: false,
                    permission: 'view_inventory'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'account-multiple',
                    title: 'Clientes',
                    path: '/admin/clients',
                    show: false,
                    permission: 'view_clients'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'chart-bar',
                    title: 'Estadísticas',
                    // path: '/admin/dashboard',
                    // show: true
                    subItems: [
                        { title: 'General', path: '/admin/dashboard', disabled: false, show: false, permission: 'view_statistics' },
                        // { title: 'Análisis', path: '/admin/physical-store', disabled: false },
                    ],
                    show: false
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'ticket-percent',
                    title: 'Cupones y descuentos',
                    path: '/admin/coupons',
                    show: false,
                    permission: 'view_coupons'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'alert-octagon',
                    title: 'Avisos',
                    path: '/admin/alerts',
                    show: false,
                    permission: 'view_notices'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'archive-clock-outline',
                    title: 'Horarios',
                    path: '/admin/schedule',
                    show: false,
                    permission: 'view_schedules'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'application-outline',
                    title: 'Páginas',
                    subItems: [
                        { title: 'Nuevo registro', path: '/admin/new-page', disabled: false, show: false, permission: 'create_pages' },
                        { title: 'Listar páginas', path: '/admin/pages', disabled: false, show: false, permission: 'view_pages' }
                    ],
                    show: false
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cogs',
                    title: 'Configuración',
                    subItems: [
                        // store
                        {
                            title: 'Mi negocio',
                            path: '/admin/my-store',
                            disabled: false,
                            show: false,
                            permission: 'view_settings_store'
                        },
                        {
                            title: 'Datos del pedido',
                            path: '/admin/my-orders',
                            disabled: false,
                            show: false,
                            permission: 'view_settings_orders'
                        },
                        {
                            title: 'Roles de la tienda',
                            path: '/admin/my-roles',
                            disabled: false,
                            show: false,
                            permission: 'view_roles'
                        },
                        {
                            title: 'Usuarios de la tienda',
                            path: '/admin/my-users',
                            disabled: false,
                            show: false,
                            permission: 'view_users'
                        }
                    ],
                    show: false
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cart',
                    title: 'Reservas',
                    path: '/admin/reservations',
                    show: false,
                    permission: 'view_reservations'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cash-register',
                    title: 'Pedidos, puntos de venta',
                    path: '/admin/cash-register',
                    show: false,
                    permission: 'view_points'
                },
                {
                    header: false,
                    role: 'store',
                    icon: 'cash-register',
                    title: 'Preventas',
                    path: '/admin/presales',
                    show: false,
                    permission: 'view_presals'
                },
                // {
                //     header: false,
                //     role: 'store',
                //     icon: 'brush-outline',
                //     title: 'Diseño',
                //     path: `https://red.quick.com.bo/?user=${this.userEmail}`,
                //     show: false,
                //     permission: 'my_account'
                // }
            ],
            ifEmergency: false,
            // notifications
            cantOrder: 0,
            cantOrder2: 0,
            cantOrder3: 0,
            // banner y logo
            banner: '',
            logo: '',
            showDrawer: false,
            // tienda fisica
            physicalStore: false,
            showBtnNewSales: false,
            showBtnNewExpense: false,
            // restaurabte fisico
            physicalRestaurant: false,
            physicalRestaurantUrl: '',
            // cash
            dialogCash: false,
            btnCloseCash: false,
            typeCash: 'open',
            // sucursales
            branches: [],
        }
    },
    props: [
        'userId',
        'userName',
        'userRole',
        'slug',
        'money',
        'userEmail',
        'typeStore'
    ],
    created() {
        this.path = window.location.pathname;
        this.findActivePath()
        if (this.userRole == 'store') {
            this.getAllNotify()
            this.getVisibleItems()
        } else {
            this.showDrawer = true
        }
        this.getEmergency()
    },
    mounted() {
        setTimeout(() => {
            this.overlay = false
        }, 500);

        if (localStorage.getItem('changeBranch')) {
            this.$fire({
                title: 'Cambio de sucursal exitoso.',
                text: 'El cambio de sucursal se ha realizado con exito.',
                type: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
            })
            localStorage.removeItem('changeBranch')
        }

        this.setSelect();
    },
    methods: {
        // notifications
        async getAllNotify() {
            await axios.get(`/admin/cant-orders/${this.slug}`)
            .then((response) => {
                // console.log(response)
                this.cantOrder = response.data[0]
                this.cantOrder2 = response.data[1]
                this.cantOrder3 = response.data[2]
                this.items[15].show = response.data[3]>0 ? true : false //"Reservas"
                
                if (response.data[4]) {
                    this.$store.dispatch('numberDecimals/setNumberDecimals', response.data[4])
                }
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // end notifications
        // menu de puntos de venta y preventas
        async getVisibleItems() {
            await axios.get(`/admin/visible-items/?slug=${this.slug}`)
            .then((response) => {
                // console.log(response);

                if (response.data.sales>0) {
                    this.items[16].show = true //"Pedidos, puntos de venta"
                }
                if (response.data.presales>0) {
                    this.items[17].show = true //"Preventas"
                }
                // console.log(this.items);

                this.physicalStore = response.data.physical ? true : false
                if (this.physicalStore) {
                    this.items[9].subItems.push({ title: 'Análisis', path: '/admin/physical-store', disabled: false, show: false, permission: 'view_statistics_analytics' }) //"Estadísticas"
                }
                this.items[9].subItems.push({ title: 'Retorno', path: '/admin/returns', disabled: false, show: false, permission: 'view_statistics_returns' }) //"Estadísticas"

                this.items[9].subItems.push({ title: 'Historial de cajas', path: '/admin/history-cashier', disabled: false, show: false, permission: 'view_history_cashier' }) //"Estadísticas"

                // show menu
                const permissions = response.data.permission
                let itemShow = false
                this.items.forEach((item, index) => {
                    if (item.role == 'store') {
                        if (item.subItems) {
                            itemShow = false
                            item.subItems.forEach(sub => {
                                if (permissions.includes(sub.permission)) {
                                    sub.show = true
                                    itemShow = true
                                } else {
                                    sub.show = false
                                }
                            });
                            // verificar la cantidad de true
                            if (itemShow) item.show = true
                        } else {
                            if (permissions.includes(item.permission)) {
                                item.show = true
                            } else {
                                item.show = false
                            }
                        }
                    } else {
                        item.show = true
                    }
                });

                if (permissions.includes('new_sale')) {
                    this.showBtnNewSales = true
                }
                if (permissions.includes('new_expense')) {
                    this.showBtnNewExpense = true
                }

                // verificar si tiene permisos de ver inventario
                if (response.data.inventory) {
                    this.items[7].show = true //"Inventario"
                }else {
                    this.items[7].show = false //"Inventario"
                }

                this.banner = response.data.banner
                this.logo = response.data.logo

                if (response.data.restaurant) {
                    this.physicalRestaurant = true
                    this.physicalRestaurantUrl = response.data.link_restaurant
                }

                if (response.data.cash) {
                    this.typeCash = 'open'
                    this.dialogCash = true
                }
                this.btnCloseCash = response.data.cash_btn?0:1

                // sucursales
                this.branches = response.data.branches

                this.findActivePath()

                setTimeout(() => {
                    this.showDrawer = true
                }, 300);
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        findActivePath () {
            this.items.forEach(element => {
                if (!element.header && element.subItems) {
                    for (let i = 0; i < element.subItems.length; i++) {
                        if (element.subItems[i].path === this.path) {
                            element.active = true
                            break
                        }
                    }
                }
            });
        },
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
         /**
          * emergency
          */
        async getEmergency() {
            await axios.post('/admin/get-emergency')
            .then((response) => {
                // console.log(response)
                this.ifEmergency = (response.data)?true:false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async changeEmergency() {
            await axios.post('/admin/change-emergency')
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', (this.ifEmergency)?'Tienda abierta.':'Tienda cerrado.', 'success', {confirmButtonText: 'Continuar'})
                    this.ifEmergency = !this.ifEmergency
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async setSelect() {
            setTimeout(async () => {
                let items = await this.getSuscrs();
                items = items.map(it => {
                    return (it.value === 'TECNOLOGIA') ? {...it, selected: true} : it;
                });
                if(items.length > 0) {
                    $('#switch-app').ddslick({
                        data: items,
                        width: '100%',
                        onSelected: (data) => {
                            console.log(`Data: ${data.selectedData.value}`);
                            if(data.selectedData.value !== 'TECNOLOGIA') {
                                this.changeApp(data.selectedData.value);
                            }
                        }
                    });
                    //$('#switch-app').ddslick('select', {value: 'TECNOLOGIA' });
                } else {
                    document.querySelector("#switch-container").style.backgroundColor = "#3c3c3c";
                }
            }, 3000);
        },
        async changeApp(app) {
            let items = await this.getSuscrs();
            let sel_app = items.find(it => it.value === app);
            let app_user_id = sel_app.usuario_id_app;

            switch (app) {
                case 'GESTION':
                    window.location.href = `https://erp.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'TECNOLOGIA':
                    window.location.href = `https://cat.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'VENTAS':
                    window.location.href = `https://crm.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'FACTURACION':
                    window.location.href = `https://fac.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'RESTAURANTE_FISICO':
                    window.location.href = `https://cat.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx?res=true`;
                    break;
                default: break;
            }
        },
        async getSuscrs() {
            try {
                let res = await axios.get('/user-suscrs', {
                    withCredentials: true,
                    headers: { Accept : "application/json" }
                });
                return res.data;
            } catch (error) { console.log(error); }
            return [];
        },
        async changeBranch(branch) {
            this.overlay = true;
            await axios.post('/admin/change-branch', {branch: branch})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    localStorage.setItem('changeBranch', true);
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false;
            })
        },
        showTutoriales() {
            try {
                let info = {
                    platform: "cat",
                    user_id: parseInt(this.userId)
                };
                let info_encoded = btoa(JSON.stringify(info));
                window.open(
                    `https://one.quick.com.bo/tutorials?info=${info_encoded}`,
                    'tutorials',
                    'width=800,height=400,menubar=no,toolbar=no,location=no,status=no,scrollbars=no,resizable=no'
                );
            } catch (error) { console.log(error); }
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
<style lang="scss">
    .v-list-item.active {
        &::before {
            opacity: 0.2;
        }
    }

    #switch-app {
        margin: 0 auto;
    }
    .dd-selected {
        border-radius: 0.5em !important;
        border: none !important;
        color: black;
    }
    .dd-select {
        background-color: white !important;
        border: solid 0px #ccc;
    }
    .dd-option-image, .dd-selected-image {
        max-width: 20px !important;
        margin-right: 1em;
    }
    .dd-selected-text, .dd-option-text {
        line-height: 20px !important;
    }
    .dd-options {
        padding-left: 0px !important;
    }
</style>
